import { HttpClient } from '@angular/common/http'
import { TranslateLoader } from '@ngx-translate/core'
import { forkJoin, Observable, of } from 'rxjs'
import { catchError, map } from 'rxjs/operators'

const TRANSLATION_FILES: string[] = ['_common', '_error', '_breadcrumb', '_sidebar', '_layout', '_admin-tools', '_mobile-app', '_partners']

export class MultiFileTranslateLoader implements TranslateLoader {
  constructor(private http: HttpClient, private basePath = './assets/i18n') {}

  getTranslation(lang: string): Observable<Record<string, any>> {
    const requests = TRANSLATION_FILES.map(file =>
      this.http.get<Record<string, any>>(`${this.basePath}/${lang}/${file}.json`).pipe(catchError(() => of({}))),
    )

    return forkJoin(requests).pipe(
      map(results => {
        const merged: Record<string, any> = {}
        for (const partial of results) {
          this.deepMerge(merged, partial)
        }
        return merged
      }),
    )
  }

  private deepMerge(target: Record<string, any>, source: Record<string, any>): Record<string, any> {
    for (const key of Object.keys(source)) {
      if (
        source[key] &&
        typeof source[key] === 'object' &&
        !Array.isArray(source[key]) &&
        target[key] &&
        typeof target[key] === 'object' &&
        !Array.isArray(target[key])
      ) {
        this.deepMerge(target[key], source[key])
      } else {
        target[key] = source[key]
      }
    }
    return target
  }
}
